import styled from 'styled-components';

import { Button, minWidth, units } from '@calm-web/design-system';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${units(1.5)};

	${minWidth('desktop')} {
		flex-direction: row;
		gap: ${units(2)};
	}
`;

export const PlayButton = styled(Button).attrs({
	backgroundColor: 'white',
	textColor: 'gray8',
})`
	${minWidth('desktop')} {
		flex: 0 0 50%;
	}
`;

export const TrailerButton = styled(Button).attrs({
	backgroundColor: 'whiteAlpha10',
})`
	${minWidth('desktop')} {
		flex: 0 0 50%;
	}
`;
